import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Button } from 'react-bootstrap';
import snakeCaseKeys from 'snakecase-keys';
import { useAbility } from '@casl/react';
import LinkBtn from '../../Utils/Button/LinkBtn';
import { createWebAttendanceRequest } from '../../../requests/attendances';
import DashboardAttendance from '../../../screens/Profile/Dashboard/DashboardAttendance';
import { SimpleCenteredModal } from '../../Utils/Modal';
import { sendAlert } from '../../../actions/utils';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';
import { profileRegisterRequest } from '../../../requests/dashboards';
import { AbilityContext } from '../../../config/abilityContext';
import { showEmployeesRequest } from '../../../requests/employees';
import DashboardActivityAttendance from '../../../screens/Profile/Dashboard/DashboardActivityAttendance';
import { createActivityAttendanceRequest } from '../../../requests/activityAttendances';
import ShowButtonBlack from '../../HRDashboardStyled/images/ShowButtonBlack.png';

const AttendanceData = ({ attendances, currentEmployee, activityAttendances }) => {
  const { advanceSettings } = useSelector(state => state.utils);
  const ability = useAbility(AbilityContext);
  const dispatch = useDispatch();
  const canCreate = ability.can('create', 'Attendance');
  const canEmployeeShow = ability.can('show', 'Employee');
  const canCreateActivity = ability.can('create', 'ActivityAttendance');
  const activityAttendance = advanceSettings
    .filter(asItem => asItem.code === 'activity_attendances')
    .some(x => x.textValue === 'true');
  const [modalShow, setModalShow] = useState(false);
  const [modalShowActivity, setModalShowActivity] = useState(false);
  const [todayRegisterCard, setTodayRegisterCard] = useState([]);
  const [branchOffices, setBranchOffices] = useState([]);
  const lastAttendance = todayRegisterCard[todayRegisterCard.length - 1];
  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleModalCloseActivity = () => {
    setModalShowActivity(false);
  };

  const handleSuccessRegisterCard = response => {
    const { data } = response;
    setTodayRegisterCard(camelCaseEmptyStringRecursive(data.attendances));
  };

  const fetchEmployeeCards = () => {
    if (currentEmployee) {
      profileRegisterRequest({
        dispatch,
        successCallback: handleSuccessRegisterCard
      });
    }
  };

  const fetchBranchOfficesEmployee = () => {
    if (currentEmployee && canEmployeeShow) {
      showEmployeesRequest(currentEmployee, {
        dispatch,
        successCallback: response => {
          setBranchOffices(response.data.contract.branch_offices || []);
        }
      });
    }
  };

  useEffect(fetchBranchOfficesEmployee, [currentEmployee]);

  useEffect(fetchEmployeeCards, [currentEmployee]);

  const handleSuccessCreate = () => {
    const message = 'Asistencia creada con éxito';
    dispatch(sendAlert({ kind: 'success', message }));
    fetchEmployeeCards();
    handleModalClose();
  };

  const handleSuccessCreateActivity = () => {
    const message = 'Actividad creada con éxito';
    dispatch(sendAlert({ kind: 'success', message }));
    fetchEmployeeCards();
    handleModalCloseActivity();
  };

  const handleFailureRequest = error => {
    const message = error.response?.data?.message;
    dispatch(sendAlert({ kind: 'error', message }));
  };

  const handleCreate = attendanceValues => {
    const params = snakeCaseKeys(attendanceValues);
    createWebAttendanceRequest({
      dispatch,
      params,
      formData: true,
      successCallback: handleSuccessCreate,
      failureCallback: handleFailureRequest
    });
  };

  const handleCreateActivity = attendanceValues => {
    const params = snakeCaseKeys(attendanceValues);
    createActivityAttendanceRequest({
      dispatch,
      params,
      formData: true,
      successCallback: handleSuccessCreateActivity,
      failureCallback: handleFailureRequest
    });
  };

  return (
    <>
      <div
        id="HRDashboard"
        style={{
          backgroundColor: '#fff',
          border: '1px solid #dc3545',
          borderRadius: '8px',
          height: '100%'
        }}
      >
        <div
          style={{
            textAlign: 'center',
            backgroundColor: '#fff',
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8
          }}
        >
          <Row>
            <Col className="mt-2" md={8} xl={8} xs={8}>
              <p
                style={{
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#d3000d',
                  textAlign: 'left',
                  marginLeft: '10px'
                }}
              >
                Asistencia
              </p>
            </Col>
            <Col md={4} xl={4} xs={4} style={{ paddingRight: '30px' }}>
              <div className="DownloadButton">
                <LinkBtn to="/profile/attendances" variant="link" className="p-0" aria-label="Ver Asistencia">
                  <img src={ShowButtonBlack} alt="Ver Asistencia" />
                </LinkBtn>
              </div>
            </Col>
          </Row>
        </div>

        <div style={{ paddingRight: 15, paddingLeft: 15 }}>
          <Row className="align-items-center">
            <Col md={6} xs={6} xl={6} className="mb-2 mb-md-0">
              <b>Tipo:</b>
              {lastAttendance ? (
                <p key={`attendance-type-${lastAttendance.id}`} className="mb-3">
                  {lastAttendance.translatedTimeType}
                </p>
              ) : (
                <p>Sin registros...</p>
              )}
            </Col>
            <Col md={6} xs={6} xl={6} className="mb-2 mb-md-0">
              <b>Hora:</b>
              {lastAttendance ? (
                <p key={`attendance-time-${lastAttendance.id}`} className="mb-3">
                  {lastAttendance.parsedTime}
                </p>
              ) : (
                <p>--:--</p>
              )}
            </Col>
          </Row>
          <Row>
            {canCreateActivity && activityAttendance ? (
              <>
                <Col md={6} xs={6} xl={6} className="mb-2">
                  {canCreate && (
                    <Button variant="warning-dash" size="sm" block onClick={() => setModalShow(true)}>
                      Marca Asistencia
                    </Button>
                  )}
                </Col>
                <Col md={6} xs={6} xl={6} className="mb-2">
                  <Button variant="primary" size="sm" block onClick={() => setModalShowActivity(true)}>
                    Reg. Actividad
                  </Button>
                </Col>
              </>
            ) : (
              <Col sm={12} md={12} className="mb-2">
                {canCreate && (
                  <Button variant="warning-dash" size="sm" block onClick={() => setModalShow(true)}>
                    Marca Asistencia
                  </Button>
                )}
              </Col>
            )}
          </Row>
        </div>
      </div>

      <SimpleCenteredModal
        title={`Marcar Asistencia ${moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}`}
        body={
          <DashboardAttendance
            handleModalClose={handleModalClose}
            formRequest={handleCreate}
            attendances={attendances}
            branchOffices={branchOffices}
          />
        }
        show={modalShow}
        size="xl"
        onHide={() => setModalShow(false)}
      />

      <SimpleCenteredModal
        title={`Registrar Actividad ${moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}`}
        body={
          <DashboardActivityAttendance
            handleModalClose={handleModalCloseActivity}
            formRequest={handleCreateActivity}
            attendances={activityAttendances}
          />
        }
        show={modalShowActivity}
        size="xl"
        onHide={() => setModalShowActivity(false)}
      />
    </>
  );
};

export default AttendanceData;
